// @ts-nocheck

import { useSelector } from 'react-redux';

import apiActionCreators from '../../../actions/api';
import { externalLinkOpen } from '../../../actions/externallink';
import useBindActionsCreator from '../../../hooks/useBindActionsCreator';
import useMergeProps from '../../../hooks/useMergeProps';
import {
  clearBasketItem,
  submit,
  onValidated,
  onError,
  onWaitingTraderValidation,
  acceptChange,
  setStake,
} from '../actions/basket';
import { ImmersiveBasket } from '../components';
import { basketSelector } from '../selectors/basket';

const { makeApiCall } = apiActionCreators;

const ImmersiveBasketContainer = () => {
  const selectedProps = useSelector(basketSelector);

  const actionsProps = useBindActionsCreator({
    makeApiCall,
    clearBasketItem,
    submit,
    acceptChange,
    setStake,
    onValidated,
    onError,
    onWaitingTraderValidation,
    openExternalLink: externalLinkOpen,
  });

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <ImmersiveBasket {...enhancedProps} />;
};

export default ImmersiveBasketContainer;
